import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Download, CheckCircle, Smartphone, FileText, Share2, DollarSign, BarChart3, Users } from 'lucide-react';

const TrainingFeedback = () => {
  const features = [
    {
      icon: Users,
      title: 'Digital Profile',
      description: 'Update on a real time basis, your Digital Trainer Profile (DigiTPro), with information on your programs, your ratings and testimonials'
    },
    {
      icon: Share2,
      title: 'Share',
      description: 'Share your latest profile (DigiTPro) with all the latest and updated information with your prospective clients'
    },
    {
      icon: DollarSign,
      title: 'Billing',
      description: 'Generate your Training Invoices, with a click of button and mail directly to client'
    },
    {
      icon: FileText,
      title: 'Report',
      description: 'Generate comprehensive, single page Training Program Feedback'
    },
    {
      icon: BarChart3,
      title: 'Participant Feedback',
      description: 'Provide, on a Client need basis, feedback on the participants'
    },
    {
      icon: CheckCircle,
      title: 'Initiate',
      description: 'Initiate a continuous learning post program, through ParticipantConnect'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <Card>
        <CardHeader>
          <CardTitle className="text-3xl font-bold text-gray-900">
            Training Feedback App
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600 leading-relaxed">
            World's Leading Training Feedback App - Download Today
          </p>
        </CardContent>
      </Card>

      {/* About Section */}
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-gray-900 flex items-center">
            <Smartphone className="w-6 h-6 mr-2 text-blue-600" />
            About Training Feedback App
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-gray-700 leading-relaxed">
            Every day, hundreds of Trainers across the world, facilitate the learning of the employees of their Client Systems – up skilling and reskilling them. And one thing that is commonly required for all these programs is a FEEDBACK at the end of the Training session.
          </p>
          <p className="text-gray-700 leading-relaxed">
            The <strong>Feedback</strong> is an important part of the whole process since it gives insights to the Provider (Trainer) as well as Recipients (the Employee/Learner and the Client) with an opportunity to evaluate, review and make changes (if any, as required). Not only that, in the Training Process, this Feedback is the first step, in what is the eventual computation of the ROI of the Training Process.
          </p>
          <p className="text-gray-700 leading-relaxed">
            The Training Feedback is therefore not just a necessity but an important part of the development analytics both for the Trainer as well as the Client (the Organization).
          </p>
        </CardContent>
      </Card>

      {/* Features Section */}
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-gray-900">
            Features - Training Feedback App
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-gray-700 leading-relaxed mb-6">
            Our App for <strong>Training Feedback</strong> is loaded with features, not merely in terms of the reporting process but also in other ways that enhances value for the Trainer and the Organizations that make crucial choices in selecting and deploying the right trainers. The features, most of which are unique and available for the first time, including feedback on participants, QR based feedback initiation (aptly suitable for Virtual Training), invoicing and billing analytics, detailed feedback reports, all make this App the most suitable for Trainers as well as Organizations.
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div key={index} className="border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-blue-600" />
                  </div>
                  <h3 className="font-bold text-gray-900 mb-2">{feature.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </CardContent>
      </Card>

      {/* Stats Card */}
      <Card className="bg-gradient-to-r from-blue-600 to-purple-600 text-white">
        <CardContent className="p-8 text-center">
          <div className="text-5xl font-bold mb-2">42,737</div>
          <div className="text-xl">Total Downloads</div>
        </CardContent>
      </Card>

      {/* Download Button */}
      <Card>
        <CardContent className="p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Download the Training Feedback App
          </h3>
          <p className="text-gray-600 mb-6">
            Available on Google Play Store
          </p>
          <Button 
            size="lg"
            className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-8 py-6 text-lg shadow-lg"
            onClick={() => window.open('https://play.google.com/store/apps/details?id=com.smt.feeddback', '_blank')}
          >
            <Download className="w-6 h-6 mr-2" />
            Download from Google Play
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default TrainingFeedback;
